import { render, staticRenderFns } from "./SuratPenunjangFormsBaseHeader.vue?vue&type=template&id=2299afb6&scoped=true&"
import script from "./SuratPenunjangFormsBaseHeader.vue?vue&type=script&lang=js&"
export * from "./SuratPenunjangFormsBaseHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuratPenunjangFormsBaseHeader.vue?vue&type=style&index=0&id=2299afb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2299afb6",
  null
  
)

export default component.exports